export const osStandardFilterFields = [
	'formulaId',
	'name',
	'formula',
	'additionalParameterIds',
	'organizationId',
] as const;

export const osDateFilterFields = ['createdAt', 'updatedAt'] as const;

export const filterFields = [...osStandardFilterFields, ...osDateFilterFields] as const;
